import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
};

/** Candle plot point data. */
export type CandlePlotPoint = {
  __typename?: 'CandlePlotPoint';
  /** Timestamp (x-axis). */
  time: Scalars['Int'];
  /** Open value (y-axis). */
  open: Scalars['Float'];
  /** Close value (y-axis). */
  close: Scalars['Float'];
  /** High value (y-axis) - not used properly. */
  high: Scalars['Float'];
  /** Low value (y-axis) - not used properly. */
  low: Scalars['Float'];
  /** Historical price TEZ(XTZ) to $(USD). */
  xtzUsdQuoteHistorical: Scalars['String'];
};

/** Percent changes by periods. */
export type Change = {
  __typename?: 'Change';
  /** Percent change by day. */
  day: Scalars['String'];
  /** Percent change by week. */
  week: Scalars['String'];
  /** Percent change by month. */
  month: Scalars['String'];
};

/** Currency Enum. */
export enum CurrencyEnum {
  Usd = 'USD',
  Xtz = 'XTZ'
}


/** Overview data for main page of Analytics. */
export type Overview = {
  __typename?: 'Overview';
  /** Actual price TEZ(XTZ) to $(USD). */
  xtzUsdQuote: Scalars['String'];
  /**
   * Liquidity of `all pairs` on Quipuswap.
   *
   * Liquidity = `TEZ` + `token` pool.
   *
   * Count in muTEZ.
   */
  totalLiquidity?: Maybe<Scalars['String']>;
  /**
   * Volume for last 24-hour period of `all pairs` on Quipuswap.
   *
   * Volume = `tezToTokenPayment` + `tokenToTezPayment` txs amounts of TEZ.
   *
   * Count in muTEZ.
   */
  volume24h?: Maybe<Scalars['String']>;
  /** Transactions count for last 24-hour period of `all pairs` on Quipuswap. */
  trasactionsCount24h: Scalars['Int'];
  /** Percent changes of `TEZ(XTZ) to $(USD) price` by periods. */
  xtzUsdQuoteChange: Change;
  /** Percent changes of `liquidity` by periods. */
  totalLiquidityChange: Change;
  /** Percent changes of `volume` by periods. */
  volumeChange: Change;
  /** Plot data for `liquidity`. */
  plotLiquidity: Array<Maybe<PlotPoint>>;
  /** Plot data for `volume`. */
  plotVolume: Array<Maybe<PlotPoint>>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

/** Pair (DEX) object from Quipuswap. */
export type Pair = {
  __typename?: 'Pair';
  CreatorId?: Maybe<Scalars['Int']>;
  /** Pair (DEX) address. */
  id?: Maybe<Scalars['String']>;
  /** Version of DEX contract. */
  version: Scalars['String'];
  /** Token data of first token in pair. */
  token1: Token;
  /** Token data of second token in pair. */
  token2: Token;
  /** First token amount in pool in lowest chunks (muTEZ for TEZ). */
  token1Pool: Scalars['String'];
  /** Second token amount in pool in lowest chunks (muTEZ for TEZ). */
  token2Pool: Scalars['String'];
  /**
   * Volume for last 24-hour period of `pair` on Quipuswap.
   *
   * Volume = `tezToTokenPayment` + `tokenToTezPayment` txs amounts of TEZ.
   *
   * Count in muTEZ.
   */
  volume24h: Scalars['Float'];
  /**
   * Volume for last 7-day period of `pair` on Quipuswap.
   *
   * Volume = `tezToTokenPayment` + `tokenToTezPayment` txs amounts of TEZ.
   *
   * Count in muTEZ.
   */
  volume7d: Scalars['Float'];
  /**
   * Liquidity of `pair` on Quipuswap.
   *
   * Liquidity = `TEZ` + `token` pool.
   *
   * Count in muTEZ.
   */
  liquidity: Scalars['Float'];
  /** Percent changes of `liquidity` by periods. */
  liquidityChange: Change;
  /** Percent changes of `volume` by periods. */
  volumeChange: Change;
  /** Percent changes of `fee` by periods. */
  feeChange: Change;
  /** Transactions count for last 24-hour period of `pair` on Quipuswap. */
  transactionsCount24h: Scalars['Int'];
  /** Plot data for `liquidity`. */
  plotLiquidity: Array<Maybe<PlotPoint>>;
  /** Plot data for `volume`. */
  plotVolume: Array<Maybe<PlotPoint>>;
};

/** Types Enum of transactions of interaction with DEX - invest/divest liquidity, swaps. */
export enum PairActionType {
  Add = 'Add',
  Remove = 'Remove',
  Swap1to2 = 'Swap1to2',
  Swap2to1 = 'Swap2to1',
  All = 'All'
}

export type PairConnection = {
  __typename?: 'PairConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PairEdge>>;
  /** Total count of entries in list. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Pair` and its cursor. */
export type PairEdge = {
  __typename?: 'PairEdge';
  /** The item at the end of the edge */
  node?: Maybe<Pair>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Transactions of interaction with DEX - invest/divest liquidity, swaps. */
export type PairTransaction = {
  __typename?: 'PairTransaction';
  /** OpHash of transaction. */
  id: Scalars['String'];
  /** Timestamp when transaction was executed. */
  timestamp: Scalars['DateTime'];
  /**
   * Type of transaction.
   * Allowed values: `Add` (investLiquidity),
   *                 `Remove` (divestLiquidity),
   *                 `Swap1to2` (tezToTokenPayment),
   *                 `Swap2to1` (tokenToTezPayment),
   *                 `All` (all of types).
   */
  trxType: PairActionType;
  /** Pair that bound to that operation. */
  pair: SimplePair;
  /** Historical price TEZ(XTZ) to $(USD). */
  xtzUsdQuoteHistorical: Scalars['String'];
  /** Amount of tokens of `Token1` in lowest chunks (muTEZ for TEZ). */
  token1Amount: Scalars['String'];
  /** Amount of tokens of `Token2` in lowest chunks (muTEZ for TEZ). */
  token2Amount: Scalars['String'];
  /** Sender address that initiated that operation. */
  sender: Scalars['String'];
};

export type PairTransactionConnection = {
  __typename?: 'PairTransactionConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PairTransactionEdge>>;
  /** Total count of entries in list. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PairTransaction` and its cursor. */
export type PairTransactionEdge = {
  __typename?: 'PairTransactionEdge';
  /** The item at the end of the edge */
  node?: Maybe<PairTransaction>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** Plot point data. */
export type PlotPoint = {
  __typename?: 'PlotPoint';
  /** Timestamp (x-axis). */
  time: Scalars['Int'];
  /** Value (y-axis). */
  value: Scalars['Float'];
  /** Historical price TEZ(XTZ) to $(USD). */
  xtzUsdQuoteHistorical: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Overview data for main page of Analytics. */
  overview: Overview;
  /**
   * `Token` data.
   *
   * IMPORTANT: Token should have at least one pair on Quipuswap!
   */
  token: Token;
  /** `Tokens` data list. */
  tokens?: Maybe<TokenConnection>;
  /** `Pair` (DEX) data. */
  pair: Pair;
  /** Quipuswap `pairs` (DEXes) data list. */
  pairs?: Maybe<PairConnection>;
  /** Transactions of interaction with DEX - `invest`/`divest` liquidity, `swaps`. */
  transactions?: Maybe<PairTransactionConnection>;
  /** Search by address of token or pair. */
  search: SearchResult;
};


export type QueryTokenArgs = {
  id: Scalars['String'];
  tokenId?: Maybe<Scalars['String']>;
};


export type QueryTokensArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  addressList?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryPairArgs = {
  id: Scalars['String'];
};


export type QueryPairsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  addressList?: Maybe<Array<Maybe<Scalars['String']>>>;
  tokenAddress?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
};


export type QueryTransactionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  scope: ScopeType;
  address?: Maybe<Scalars['String']>;
  trxType?: Maybe<PairActionType>;
  tokenId?: Maybe<Scalars['String']>;
};


export type QuerySearchArgs = {
  address: Scalars['String'];
};

/**
 * Scope of transactions.
 *
 * Allowed values: `Overview`, `Token`, `Pair`, `Account`.
 */
export enum ScopeType {
  Overview = 'Overview',
  Token = 'Token',
  Pair = 'Pair',
  Account = 'Account'
}

/** Search result. */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** List of `minimal tokens` data. */
  tokens?: Maybe<Array<Maybe<SimpleToken>>>;
  /** List of `minimal pairs` (DEXes) data. */
  pairs?: Maybe<Array<Maybe<SimplePair>>>;
};

/** Minimal pair (DEX) object from Quipuswap. */
export type SimplePair = {
  __typename?: 'SimplePair';
  /** Pair (DEX) address. */
  id?: Maybe<Scalars['String']>;
  /** Version of DEX contract. */
  version: Scalars['String'];
  /** Minimal token data of first token in pair. */
  token1: SimpleToken;
  /** Minimal token data of second token in pair. */
  token2: SimpleToken;
};

/** Minimal token object. */
export type SimpleToken = {
  __typename?: 'SimpleToken';
  /** `Token address`. */
  id?: Maybe<Scalars['String']>;
  /** `Token ID` for `FA2` tokens. */
  tokenId?: Maybe<Scalars['String']>;
  /** Token name from metadata. */
  name?: Maybe<Scalars['String']>;
  /** Token symbol from metadata. */
  symbol?: Maybe<Scalars['String']>;
  /** Token decimals from metadata. */
  decimals?: Maybe<Scalars['String']>;
  /** Token icon from metadata. */
  icon?: Maybe<Scalars['String']>;
};

/** Token Standard Enum. */
export enum Standard {
  Null = 'Null',
  Fa12 = 'FA12',
  Fa2 = 'FA2'
}

/** Token object. */
export type Token = {
  __typename?: 'Token';
  CreatorId?: Maybe<Scalars['Int']>;
  /** `Token address`. */
  id?: Maybe<Scalars['String']>;
  /** `Token ID` for `FA2` tokens. */
  tokenId?: Maybe<Scalars['String']>;
  /** Token name from metadata. */
  name?: Maybe<Scalars['String']>;
  /** Token symbol from metadata. */
  symbol?: Maybe<Scalars['String']>;
  /** Token decimals from metadata. */
  decimals?: Maybe<Scalars['String']>;
  /** Token icon from metadata. */
  icon?: Maybe<Scalars['String']>;
  /** Token standard (FA12/FA2/Null(for Tezos)) */
  standard: Standard;
  /**
   * Volume for last 24-hour period of `Token` on Quipuswap.
   *
   * Volume = `tezToTokenPayment` + `tokenToTezPayment` txs amounts of TEZ.
   *
   * Count in muTEZ.
   */
  volume24h: Scalars['String'];
  /**
   * `Token` price.
   * Price count from `pair` (DEX) with greatest `liquidity`.
   * Count in TEZ.
   */
  price: Scalars['String'];
  /**
   * Liquidity of `Token` on Quipuswap.
   *
   * Liquidity = `TEZ` + `token` pool.
   *
   * Count in muTEZ.
   */
  liquidity: Scalars['String'];
  /** Transactions count for last 24-hour period of `Token` on Quipuswap. */
  transactionsCount24h: Scalars['Int'];
  /** Percent changes of `TEZ(XTZ) or $(USD) price of  `Token`` by periods. */
  priceChange: Change;
  /** Percent changes of `liquidity` by periods. */
  liquidityChange: Change;
  /** Percent changes of `volume` by periods. */
  volumeChange: Change;
  /** Plot data for `price`. */
  plotPrice: Array<Maybe<CandlePlotPoint>>;
  /** Plot data for `liquidity`. */
  plotLiquidity: Array<Maybe<PlotPoint>>;
  /** Plot data for `volume`. */
  plotVolume: Array<Maybe<PlotPoint>>;
};


/** Token object. */
export type TokenPriceChangeArgs = {
  currency?: Maybe<CurrencyEnum>;
};

export type TokenConnection = {
  __typename?: 'TokenConnection';
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TokenEdge>>;
  /** Total count of entries in list. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Token` and its cursor. */
export type TokenEdge = {
  __typename?: 'TokenEdge';
  /** The item at the end of the edge */
  node?: Maybe<Token>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

export type GetSearchDataQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type GetSearchDataQuery = (
  { __typename?: 'Query' }
  & { search: (
    { __typename?: 'SearchResult' }
    & { tokens?: Maybe<Array<Maybe<(
      { __typename?: 'SimpleToken' }
      & Pick<SimpleToken, 'id' | 'tokenId' | 'name' | 'symbol' | 'icon'>
    )>>>, pairs?: Maybe<Array<Maybe<(
      { __typename?: 'SimplePair' }
      & Pick<SimplePair, 'id' | 'version'>
      & { token1: (
        { __typename?: 'SimpleToken' }
        & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'icon'>
      ), token2: (
        { __typename?: 'SimpleToken' }
        & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'icon'>
      ) }
    )>>> }
  ) }
);

export type InfoTabsQueryVariables = Exact<{ [key: string]: never; }>;


export type InfoTabsQuery = (
  { __typename?: 'Query' }
  & { overview: (
    { __typename?: 'Overview' }
    & Pick<Overview, 'xtzUsdQuote' | 'trasactionsCount24h' | 'totalLiquidity' | 'volume24h'>
    & { xtzUsdQuoteChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), totalLiquidityChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), volumeChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), plotVolume: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>>, plotLiquidity: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetTokensQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  currency?: Maybe<CurrencyEnum>;
}>;


export type GetTokensQuery = (
  { __typename?: 'Query' }
  & { tokens?: Maybe<(
    { __typename?: 'TokenConnection' }
    & Pick<TokenConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'TokenEdge' }
      & { node?: Maybe<(
        { __typename?: 'Token' }
        & Pick<Token, 'id' | 'icon' | 'name' | 'standard' | 'volume24h' | 'price' | 'symbol' | 'tokenId' | 'liquidity'>
        & { priceChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetPairsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetPairsQuery = (
  { __typename?: 'Query' }
  & { pairs?: Maybe<(
    { __typename?: 'PairConnection' }
    & Pick<PairConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'PairEdge' }
      & { node?: Maybe<(
        { __typename?: 'Pair' }
        & Pick<Pair, 'id' | 'version' | 'liquidity' | 'volume24h' | 'volume7d'>
        & { token1: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'standard' | 'icon' | 'tokenId' | 'symbol'>
        ), token2: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'standard' | 'icon' | 'tokenId' | 'symbol'>
        ), volumeChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetTransactionQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  scope: ScopeType;
  trxType?: Maybe<PairActionType>;
}>;


export type GetTransactionQuery = (
  { __typename?: 'Query' }
  & { transactions?: Maybe<(
    { __typename?: 'PairTransactionConnection' }
    & Pick<PairTransactionConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'PairTransactionEdge' }
      & { node?: Maybe<(
        { __typename?: 'PairTransaction' }
        & Pick<PairTransaction, 'trxType' | 'token1Amount' | 'token2Amount' | 'id' | 'timestamp' | 'sender' | 'xtzUsdQuoteHistorical'>
        & { pair: (
          { __typename?: 'SimplePair' }
          & Pick<SimplePair, 'id'>
          & { token1: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ), token2: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ) }
        ) }
      )> }
    )>> }
  )> }
);

export type GetPairQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPairQuery = (
  { __typename?: 'Query' }
  & { pair: (
    { __typename?: 'Pair' }
    & Pick<Pair, 'id' | 'version' | 'liquidity' | 'volume24h' | 'volume7d' | 'transactionsCount24h' | 'token1Pool' | 'token2Pool'>
    & { token1: (
      { __typename?: 'Token' }
      & Pick<Token, 'id' | 'standard' | 'icon' | 'tokenId' | 'symbol' | 'price' | 'name' | 'decimals'>
    ), token2: (
      { __typename?: 'Token' }
      & Pick<Token, 'id' | 'standard' | 'icon' | 'tokenId' | 'symbol' | 'name' | 'price' | 'decimals'>
    ), liquidityChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), volumeChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ) }
  ) }
);

export type GetPairPlotLiquidityQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPairPlotLiquidityQuery = (
  { __typename?: 'Query' }
  & { pair: (
    { __typename?: 'Pair' }
    & { plotLiquidity: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetPairPlotVolumeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPairPlotVolumeQuery = (
  { __typename?: 'Query' }
  & { pair: (
    { __typename?: 'Pair' }
    & { plotVolume: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetXtzCurrentPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetXtzCurrentPriceQuery = (
  { __typename?: 'Query' }
  & { overview: (
    { __typename?: 'Overview' }
    & Pick<Overview, 'xtzUsdQuote'>
  ) }
);

export type GetTransactionsByPairQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  scope: ScopeType;
  trxType?: Maybe<PairActionType>;
  address?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetTransactionsByPairQuery = (
  { __typename?: 'Query' }
  & { transactions?: Maybe<(
    { __typename?: 'PairTransactionConnection' }
    & Pick<PairTransactionConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'PairTransactionEdge' }
      & { node?: Maybe<(
        { __typename?: 'PairTransaction' }
        & Pick<PairTransaction, 'trxType' | 'token1Amount' | 'token2Amount' | 'id' | 'timestamp' | 'sender' | 'xtzUsdQuoteHistorical'>
        & { pair: (
          { __typename?: 'SimplePair' }
          & Pick<SimplePair, 'id'>
          & { token1: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ), token2: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ) }
        ) }
      )> }
    )>> }
  )> }
);

export type GetAllPairsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetAllPairsQuery = (
  { __typename?: 'Query' }
  & { pairs?: Maybe<(
    { __typename?: 'PairConnection' }
    & Pick<PairConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'PairEdge' }
      & { node?: Maybe<(
        { __typename?: 'Pair' }
        & Pick<Pair, 'id' | 'version' | 'liquidity' | 'volume24h' | 'volume7d'>
        & { token1: (
          { __typename?: 'Token' }
          & Pick<Token, 'icon' | 'symbol'>
        ), token2: (
          { __typename?: 'Token' }
          & Pick<Token, 'icon' | 'symbol'>
        ), volumeChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetSavedPairsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  pairsAddressList?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GetSavedPairsQuery = (
  { __typename?: 'Query' }
  & { pairs?: Maybe<(
    { __typename?: 'PairConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'PairEdge' }
      & { node?: Maybe<(
        { __typename?: 'Pair' }
        & Pick<Pair, 'id' | 'version' | 'liquidity' | 'volume24h' | 'volume7d'>
        & { token1: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'tokenId' | 'icon' | 'symbol'>
        ), token2: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'tokenId' | 'icon' | 'symbol'>
        ), volumeChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetSavedTokensQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  tokensAddressList?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  currency?: Maybe<CurrencyEnum>;
}>;


export type GetSavedTokensQuery = (
  { __typename?: 'Query' }
  & { tokens?: Maybe<(
    { __typename?: 'TokenConnection' }
    & { edges: Array<Maybe<(
      { __typename?: 'TokenEdge' }
      & { node?: Maybe<(
        { __typename?: 'Token' }
        & Pick<Token, 'id' | 'icon' | 'name' | 'standard' | 'volume24h' | 'price' | 'symbol' | 'tokenId' | 'liquidity'>
        & { priceChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetTokenQueryVariables = Exact<{
  id: Scalars['String'];
  tokenId?: Maybe<Scalars['String']>;
  currency?: Maybe<CurrencyEnum>;
}>;


export type GetTokenQuery = (
  { __typename?: 'Query' }
  & { token: (
    { __typename?: 'Token' }
    & Pick<Token, 'id' | 'standard' | 'tokenId' | 'icon' | 'name' | 'symbol' | 'price' | 'liquidity' | 'volume24h' | 'transactionsCount24h'>
    & { priceChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), liquidityChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ), volumeChange: (
      { __typename?: 'Change' }
      & Pick<Change, 'day' | 'week' | 'month'>
    ) }
  ) }
);

export type GetPairsByTokenQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  tokenAddress?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetPairsByTokenQuery = (
  { __typename?: 'Query' }
  & { pairs?: Maybe<(
    { __typename?: 'PairConnection' }
    & Pick<PairConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'PairEdge' }
      & { node?: Maybe<(
        { __typename?: 'Pair' }
        & Pick<Pair, 'id' | 'version' | 'liquidity' | 'volume24h' | 'volume7d'>
        & { token1: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'icon' | 'tokenId' | 'symbol'>
        ), token2: (
          { __typename?: 'Token' }
          & Pick<Token, 'id' | 'icon' | 'standard' | 'tokenId' | 'symbol'>
        ), volumeChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);

export type GetTransactionsByTokenQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  scope: ScopeType;
  trxType?: Maybe<PairActionType>;
  address?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetTransactionsByTokenQuery = (
  { __typename?: 'Query' }
  & { transactions?: Maybe<(
    { __typename?: 'PairTransactionConnection' }
    & Pick<PairTransactionConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage'>
    ), edges: Array<Maybe<(
      { __typename?: 'PairTransactionEdge' }
      & { node?: Maybe<(
        { __typename?: 'PairTransaction' }
        & Pick<PairTransaction, 'trxType' | 'token1Amount' | 'token2Amount' | 'id' | 'timestamp' | 'sender' | 'xtzUsdQuoteHistorical'>
        & { pair: (
          { __typename?: 'SimplePair' }
          & Pick<SimplePair, 'id'>
          & { token1: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ), token2: (
            { __typename?: 'SimpleToken' }
            & Pick<SimpleToken, 'id' | 'tokenId' | 'symbol' | 'decimals'>
          ) }
        ) }
      )> }
    )>> }
  )> }
);

export type GetTokenPlotVolumeQueryVariables = Exact<{
  id: Scalars['String'];
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetTokenPlotVolumeQuery = (
  { __typename?: 'Query' }
  & { token: (
    { __typename?: 'Token' }
    & Pick<Token, 'id' | 'tokenId'>
    & { plotVolume: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetTokenPlotLiquidityQueryVariables = Exact<{
  id: Scalars['String'];
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetTokenPlotLiquidityQuery = (
  { __typename?: 'Query' }
  & { token: (
    { __typename?: 'Token' }
    & Pick<Token, 'id' | 'tokenId'>
    & { plotLiquidity: Array<Maybe<(
      { __typename?: 'PlotPoint' }
      & Pick<PlotPoint, 'time' | 'value' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetTokenPlotPriceQueryVariables = Exact<{
  id: Scalars['String'];
  tokenId?: Maybe<Scalars['String']>;
}>;


export type GetTokenPlotPriceQuery = (
  { __typename?: 'Query' }
  & { token: (
    { __typename?: 'Token' }
    & Pick<Token, 'id' | 'tokenId'>
    & { plotPrice: Array<Maybe<(
      { __typename?: 'CandlePlotPoint' }
      & Pick<CandlePlotPoint, 'time' | 'open' | 'close' | 'high' | 'low' | 'xtzUsdQuoteHistorical'>
    )>> }
  ) }
);

export type GetAllTokensQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  currency?: Maybe<CurrencyEnum>;
}>;


export type GetAllTokensQuery = (
  { __typename?: 'Query' }
  & { tokens?: Maybe<(
    { __typename?: 'TokenConnection' }
    & Pick<TokenConnection, 'totalCount'>
    & { edges: Array<Maybe<(
      { __typename?: 'TokenEdge' }
      & { node?: Maybe<(
        { __typename?: 'Token' }
        & Pick<Token, 'id' | 'icon' | 'name' | 'standard' | 'volume24h' | 'price' | 'symbol' | 'tokenId' | 'liquidity'>
        & { priceChange: (
          { __typename?: 'Change' }
          & Pick<Change, 'day' | 'week' | 'month'>
        ) }
      )> }
    )>> }
  )> }
);


export const GetSearchDataDocument = gql`
    query GetSearchData($address: String!) {
  search(address: $address) {
    tokens {
      id
      tokenId
      name
      symbol
      icon
    }
    pairs {
      id
      version
      token1 {
        id
        tokenId
        symbol
        icon
      }
      token2 {
        id
        tokenId
        symbol
        icon
      }
    }
  }
}
    `;

/**
 * __useGetSearchDataQuery__
 *
 * To run a query within a React component, call `useGetSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchDataQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetSearchDataQuery(baseOptions: Apollo.QueryHookOptions<GetSearchDataQuery, GetSearchDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchDataQuery, GetSearchDataQueryVariables>(GetSearchDataDocument, options);
      }
export function useGetSearchDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchDataQuery, GetSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchDataQuery, GetSearchDataQueryVariables>(GetSearchDataDocument, options);
        }
export type GetSearchDataQueryHookResult = ReturnType<typeof useGetSearchDataQuery>;
export type GetSearchDataLazyQueryHookResult = ReturnType<typeof useGetSearchDataLazyQuery>;
export type GetSearchDataQueryResult = Apollo.QueryResult<GetSearchDataQuery, GetSearchDataQueryVariables>;
export const InfoTabsDocument = gql`
    query InfoTabs {
  overview {
    xtzUsdQuote
    xtzUsdQuoteChange {
      day
      week
      month
    }
    trasactionsCount24h
    totalLiquidityChange {
      day
      week
      month
    }
    totalLiquidity
    volume24h
    volumeChange {
      day
      week
      month
    }
    plotVolume {
      time
      value
      xtzUsdQuoteHistorical
    }
    plotLiquidity {
      time
      value
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useInfoTabsQuery__
 *
 * To run a query within a React component, call `useInfoTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoTabsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInfoTabsQuery(baseOptions?: Apollo.QueryHookOptions<InfoTabsQuery, InfoTabsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoTabsQuery, InfoTabsQueryVariables>(InfoTabsDocument, options);
      }
export function useInfoTabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoTabsQuery, InfoTabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoTabsQuery, InfoTabsQueryVariables>(InfoTabsDocument, options);
        }
export type InfoTabsQueryHookResult = ReturnType<typeof useInfoTabsQuery>;
export type InfoTabsLazyQueryHookResult = ReturnType<typeof useInfoTabsLazyQuery>;
export type InfoTabsQueryResult = Apollo.QueryResult<InfoTabsQuery, InfoTabsQueryVariables>;
export const GetTokensDocument = gql`
    query GetTokens($limit: Int, $offset: Int, $currency: CurrencyEnum) {
  tokens(limit: $limit, offset: $offset) {
    totalCount
    edges {
      node {
        id
        icon
        name
        standard
        volume24h
        price
        symbol
        tokenId
        priceChange(currency: $currency) {
          day
          week
          month
        }
        liquidity
      }
    }
  }
}
    `;

/**
 * __useGetTokensQuery__
 *
 * To run a query within a React component, call `useGetTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokensQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetTokensQuery(baseOptions?: Apollo.QueryHookOptions<GetTokensQuery, GetTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokensQuery, GetTokensQueryVariables>(GetTokensDocument, options);
      }
export function useGetTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokensQuery, GetTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokensQuery, GetTokensQueryVariables>(GetTokensDocument, options);
        }
export type GetTokensQueryHookResult = ReturnType<typeof useGetTokensQuery>;
export type GetTokensLazyQueryHookResult = ReturnType<typeof useGetTokensLazyQuery>;
export type GetTokensQueryResult = Apollo.QueryResult<GetTokensQuery, GetTokensQueryVariables>;
export const GetPairsDocument = gql`
    query GetPairs($limit: Int, $offset: Int) {
  pairs(limit: $limit, offset: $offset) {
    totalCount
    edges {
      node {
        id
        version
        token1 {
          id
          standard
          icon
          tokenId
          symbol
        }
        token2 {
          id
          standard
          icon
          tokenId
          symbol
        }
        liquidity
        volume24h
        volume7d
        volumeChange {
          day
          week
          month
        }
      }
    }
  }
}
    `;

/**
 * __useGetPairsQuery__
 *
 * To run a query within a React component, call `useGetPairsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPairsQuery(baseOptions?: Apollo.QueryHookOptions<GetPairsQuery, GetPairsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPairsQuery, GetPairsQueryVariables>(GetPairsDocument, options);
      }
export function useGetPairsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPairsQuery, GetPairsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPairsQuery, GetPairsQueryVariables>(GetPairsDocument, options);
        }
export type GetPairsQueryHookResult = ReturnType<typeof useGetPairsQuery>;
export type GetPairsLazyQueryHookResult = ReturnType<typeof useGetPairsLazyQuery>;
export type GetPairsQueryResult = Apollo.QueryResult<GetPairsQuery, GetPairsQueryVariables>;
export const GetTransactionDocument = gql`
    query GetTransaction($limit: Int!, $offset: Int!, $scope: ScopeType!, $trxType: PairActionType) {
  transactions(limit: $limit, offset: $offset, scope: $scope, trxType: $trxType) {
    totalCount
    edges {
      node {
        trxType
        token1Amount
        token2Amount
        id
        timestamp
        sender
        xtzUsdQuoteHistorical
        pair {
          id
          token1 {
            id
            tokenId
            symbol
            decimals
          }
          token2 {
            id
            tokenId
            symbol
            tokenId
            decimals
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      scope: // value for 'scope'
 *      trxType: // value for 'trxType'
 *   },
 * });
 */
export function useGetTransactionQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
        }
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetPairDocument = gql`
    query GetPair($id: String!) {
  pair(id: $id) {
    id
    version
    token1 {
      id
      standard
      icon
      tokenId
      symbol
      price
      name
      decimals
    }
    token2 {
      id
      standard
      icon
      tokenId
      symbol
      name
      price
      decimals
    }
    liquidity
    liquidityChange {
      day
      week
      month
    }
    volume24h
    volume7d
    volumeChange {
      day
      week
      month
    }
    volumeChange {
      day
      week
      month
    }
    transactionsCount24h
    token1Pool
    token2Pool
  }
}
    `;

/**
 * __useGetPairQuery__
 *
 * To run a query within a React component, call `useGetPairQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPairQuery(baseOptions: Apollo.QueryHookOptions<GetPairQuery, GetPairQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPairQuery, GetPairQueryVariables>(GetPairDocument, options);
      }
export function useGetPairLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPairQuery, GetPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPairQuery, GetPairQueryVariables>(GetPairDocument, options);
        }
export type GetPairQueryHookResult = ReturnType<typeof useGetPairQuery>;
export type GetPairLazyQueryHookResult = ReturnType<typeof useGetPairLazyQuery>;
export type GetPairQueryResult = Apollo.QueryResult<GetPairQuery, GetPairQueryVariables>;
export const GetPairPlotLiquidityDocument = gql`
    query GetPairPlotLiquidity($id: String!) {
  pair(id: $id) {
    plotLiquidity {
      time
      value
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useGetPairPlotLiquidityQuery__
 *
 * To run a query within a React component, call `useGetPairPlotLiquidityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairPlotLiquidityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairPlotLiquidityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPairPlotLiquidityQuery(baseOptions: Apollo.QueryHookOptions<GetPairPlotLiquidityQuery, GetPairPlotLiquidityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPairPlotLiquidityQuery, GetPairPlotLiquidityQueryVariables>(GetPairPlotLiquidityDocument, options);
      }
export function useGetPairPlotLiquidityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPairPlotLiquidityQuery, GetPairPlotLiquidityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPairPlotLiquidityQuery, GetPairPlotLiquidityQueryVariables>(GetPairPlotLiquidityDocument, options);
        }
export type GetPairPlotLiquidityQueryHookResult = ReturnType<typeof useGetPairPlotLiquidityQuery>;
export type GetPairPlotLiquidityLazyQueryHookResult = ReturnType<typeof useGetPairPlotLiquidityLazyQuery>;
export type GetPairPlotLiquidityQueryResult = Apollo.QueryResult<GetPairPlotLiquidityQuery, GetPairPlotLiquidityQueryVariables>;
export const GetPairPlotVolumeDocument = gql`
    query GetPairPlotVolume($id: String!) {
  pair(id: $id) {
    plotVolume {
      time
      value
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useGetPairPlotVolumeQuery__
 *
 * To run a query within a React component, call `useGetPairPlotVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairPlotVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairPlotVolumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPairPlotVolumeQuery(baseOptions: Apollo.QueryHookOptions<GetPairPlotVolumeQuery, GetPairPlotVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPairPlotVolumeQuery, GetPairPlotVolumeQueryVariables>(GetPairPlotVolumeDocument, options);
      }
export function useGetPairPlotVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPairPlotVolumeQuery, GetPairPlotVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPairPlotVolumeQuery, GetPairPlotVolumeQueryVariables>(GetPairPlotVolumeDocument, options);
        }
export type GetPairPlotVolumeQueryHookResult = ReturnType<typeof useGetPairPlotVolumeQuery>;
export type GetPairPlotVolumeLazyQueryHookResult = ReturnType<typeof useGetPairPlotVolumeLazyQuery>;
export type GetPairPlotVolumeQueryResult = Apollo.QueryResult<GetPairPlotVolumeQuery, GetPairPlotVolumeQueryVariables>;
export const GetXtzCurrentPriceDocument = gql`
    query GetXtzCurrentPrice {
  overview {
    xtzUsdQuote
  }
}
    `;

/**
 * __useGetXtzCurrentPriceQuery__
 *
 * To run a query within a React component, call `useGetXtzCurrentPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetXtzCurrentPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetXtzCurrentPriceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetXtzCurrentPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetXtzCurrentPriceQuery, GetXtzCurrentPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetXtzCurrentPriceQuery, GetXtzCurrentPriceQueryVariables>(GetXtzCurrentPriceDocument, options);
      }
export function useGetXtzCurrentPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetXtzCurrentPriceQuery, GetXtzCurrentPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetXtzCurrentPriceQuery, GetXtzCurrentPriceQueryVariables>(GetXtzCurrentPriceDocument, options);
        }
export type GetXtzCurrentPriceQueryHookResult = ReturnType<typeof useGetXtzCurrentPriceQuery>;
export type GetXtzCurrentPriceLazyQueryHookResult = ReturnType<typeof useGetXtzCurrentPriceLazyQuery>;
export type GetXtzCurrentPriceQueryResult = Apollo.QueryResult<GetXtzCurrentPriceQuery, GetXtzCurrentPriceQueryVariables>;
export const GetTransactionsByPairDocument = gql`
    query GetTransactionsByPair($limit: Int!, $offset: Int!, $scope: ScopeType!, $trxType: PairActionType, $address: String, $tokenId: String) {
  transactions(
    limit: $limit
    offset: $offset
    scope: $scope
    trxType: $trxType
    address: $address
    tokenId: $tokenId
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        trxType
        token1Amount
        token2Amount
        id
        timestamp
        sender
        xtzUsdQuoteHistorical
        pair {
          id
          token1 {
            id
            tokenId
            symbol
            decimals
          }
          token2 {
            id
            tokenId
            symbol
            tokenId
            decimals
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransactionsByPairQuery__
 *
 * To run a query within a React component, call `useGetTransactionsByPairQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsByPairQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsByPairQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      scope: // value for 'scope'
 *      trxType: // value for 'trxType'
 *      address: // value for 'address'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetTransactionsByPairQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsByPairQuery, GetTransactionsByPairQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsByPairQuery, GetTransactionsByPairQueryVariables>(GetTransactionsByPairDocument, options);
      }
export function useGetTransactionsByPairLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsByPairQuery, GetTransactionsByPairQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsByPairQuery, GetTransactionsByPairQueryVariables>(GetTransactionsByPairDocument, options);
        }
export type GetTransactionsByPairQueryHookResult = ReturnType<typeof useGetTransactionsByPairQuery>;
export type GetTransactionsByPairLazyQueryHookResult = ReturnType<typeof useGetTransactionsByPairLazyQuery>;
export type GetTransactionsByPairQueryResult = Apollo.QueryResult<GetTransactionsByPairQuery, GetTransactionsByPairQueryVariables>;
export const GetAllPairsDocument = gql`
    query GetAllPairs($limit: Int, $offset: Int) {
  pairs(limit: $limit, offset: $offset) {
    totalCount
    edges {
      node {
        id
        version
        token1 {
          icon
          symbol
        }
        token2 {
          icon
          symbol
        }
        liquidity
        volume24h
        volume7d
        volumeChange {
          day
          week
          month
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllPairsQuery__
 *
 * To run a query within a React component, call `useGetAllPairsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPairsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPairsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAllPairsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPairsQuery, GetAllPairsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPairsQuery, GetAllPairsQueryVariables>(GetAllPairsDocument, options);
      }
export function useGetAllPairsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPairsQuery, GetAllPairsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPairsQuery, GetAllPairsQueryVariables>(GetAllPairsDocument, options);
        }
export type GetAllPairsQueryHookResult = ReturnType<typeof useGetAllPairsQuery>;
export type GetAllPairsLazyQueryHookResult = ReturnType<typeof useGetAllPairsLazyQuery>;
export type GetAllPairsQueryResult = Apollo.QueryResult<GetAllPairsQuery, GetAllPairsQueryVariables>;
export const GetSavedPairsDocument = gql`
    query GetSavedPairs($limit: Int, $offset: Int, $pairsAddressList: [String]) {
  pairs(limit: $limit, offset: $offset, addressList: $pairsAddressList) {
    edges {
      node {
        id
        version
        token1 {
          id
          tokenId
          icon
          symbol
        }
        token2 {
          id
          tokenId
          icon
          symbol
        }
        liquidity
        volume24h
        volume7d
        volumeChange {
          day
          week
          month
        }
      }
    }
  }
}
    `;

/**
 * __useGetSavedPairsQuery__
 *
 * To run a query within a React component, call `useGetSavedPairsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedPairsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedPairsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      pairsAddressList: // value for 'pairsAddressList'
 *   },
 * });
 */
export function useGetSavedPairsQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedPairsQuery, GetSavedPairsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedPairsQuery, GetSavedPairsQueryVariables>(GetSavedPairsDocument, options);
      }
export function useGetSavedPairsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedPairsQuery, GetSavedPairsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedPairsQuery, GetSavedPairsQueryVariables>(GetSavedPairsDocument, options);
        }
export type GetSavedPairsQueryHookResult = ReturnType<typeof useGetSavedPairsQuery>;
export type GetSavedPairsLazyQueryHookResult = ReturnType<typeof useGetSavedPairsLazyQuery>;
export type GetSavedPairsQueryResult = Apollo.QueryResult<GetSavedPairsQuery, GetSavedPairsQueryVariables>;
export const GetSavedTokensDocument = gql`
    query GetSavedTokens($limit: Int, $offset: Int, $tokensAddressList: [String], $currency: CurrencyEnum) {
  tokens(limit: $limit, offset: $offset, addressList: $tokensAddressList) {
    edges {
      node {
        id
        icon
        name
        standard
        volume24h
        price
        symbol
        tokenId
        priceChange(currency: $currency) {
          day
          week
          month
        }
        liquidity
      }
    }
  }
}
    `;

/**
 * __useGetSavedTokensQuery__
 *
 * To run a query within a React component, call `useGetSavedTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedTokensQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tokensAddressList: // value for 'tokensAddressList'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetSavedTokensQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedTokensQuery, GetSavedTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedTokensQuery, GetSavedTokensQueryVariables>(GetSavedTokensDocument, options);
      }
export function useGetSavedTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedTokensQuery, GetSavedTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedTokensQuery, GetSavedTokensQueryVariables>(GetSavedTokensDocument, options);
        }
export type GetSavedTokensQueryHookResult = ReturnType<typeof useGetSavedTokensQuery>;
export type GetSavedTokensLazyQueryHookResult = ReturnType<typeof useGetSavedTokensLazyQuery>;
export type GetSavedTokensQueryResult = Apollo.QueryResult<GetSavedTokensQuery, GetSavedTokensQueryVariables>;
export const GetTokenDocument = gql`
    query GetToken($id: String!, $tokenId: String, $currency: CurrencyEnum) {
  token(id: $id, tokenId: $tokenId) {
    id
    standard
    tokenId
    icon
    name
    symbol
    price
    priceChange(currency: $currency) {
      day
      week
      month
    }
    liquidity
    liquidityChange {
      day
      week
      month
    }
    volume24h
    volumeChange {
      day
      week
      month
    }
    transactionsCount24h
  }
}
    `;

/**
 * __useGetTokenQuery__
 *
 * To run a query within a React component, call `useGetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tokenId: // value for 'tokenId'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetTokenQuery(baseOptions: Apollo.QueryHookOptions<GetTokenQuery, GetTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenQuery, GetTokenQueryVariables>(GetTokenDocument, options);
      }
export function useGetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenQuery, GetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenQuery, GetTokenQueryVariables>(GetTokenDocument, options);
        }
export type GetTokenQueryHookResult = ReturnType<typeof useGetTokenQuery>;
export type GetTokenLazyQueryHookResult = ReturnType<typeof useGetTokenLazyQuery>;
export type GetTokenQueryResult = Apollo.QueryResult<GetTokenQuery, GetTokenQueryVariables>;
export const GetPairsByTokenDocument = gql`
    query GetPairsByToken($limit: Int, $offset: Int, $tokenAddress: String, $tokenId: String) {
  pairs(
    limit: $limit
    offset: $offset
    tokenId: $tokenId
    tokenAddress: $tokenAddress
  ) {
    totalCount
    edges {
      node {
        id
        version
        token1 {
          id
          icon
          tokenId
          symbol
        }
        token2 {
          id
          icon
          standard
          tokenId
          symbol
        }
        liquidity
        volume24h
        volume7d
        volumeChange {
          day
          week
          month
        }
      }
    }
  }
}
    `;

/**
 * __useGetPairsByTokenQuery__
 *
 * To run a query within a React component, call `useGetPairsByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPairsByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPairsByTokenQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tokenAddress: // value for 'tokenAddress'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetPairsByTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetPairsByTokenQuery, GetPairsByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPairsByTokenQuery, GetPairsByTokenQueryVariables>(GetPairsByTokenDocument, options);
      }
export function useGetPairsByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPairsByTokenQuery, GetPairsByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPairsByTokenQuery, GetPairsByTokenQueryVariables>(GetPairsByTokenDocument, options);
        }
export type GetPairsByTokenQueryHookResult = ReturnType<typeof useGetPairsByTokenQuery>;
export type GetPairsByTokenLazyQueryHookResult = ReturnType<typeof useGetPairsByTokenLazyQuery>;
export type GetPairsByTokenQueryResult = Apollo.QueryResult<GetPairsByTokenQuery, GetPairsByTokenQueryVariables>;
export const GetTransactionsByTokenDocument = gql`
    query GetTransactionsByToken($limit: Int!, $offset: Int!, $scope: ScopeType!, $trxType: PairActionType, $address: String, $tokenId: String) {
  transactions(
    limit: $limit
    offset: $offset
    scope: $scope
    trxType: $trxType
    address: $address
    tokenId: $tokenId
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        trxType
        token1Amount
        token2Amount
        id
        timestamp
        sender
        xtzUsdQuoteHistorical
        pair {
          id
          token1 {
            id
            tokenId
            symbol
            decimals
          }
          token2 {
            id
            tokenId
            symbol
            tokenId
            decimals
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransactionsByTokenQuery__
 *
 * To run a query within a React component, call `useGetTransactionsByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsByTokenQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      scope: // value for 'scope'
 *      trxType: // value for 'trxType'
 *      address: // value for 'address'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetTransactionsByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetTransactionsByTokenQuery, GetTransactionsByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsByTokenQuery, GetTransactionsByTokenQueryVariables>(GetTransactionsByTokenDocument, options);
      }
export function useGetTransactionsByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsByTokenQuery, GetTransactionsByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsByTokenQuery, GetTransactionsByTokenQueryVariables>(GetTransactionsByTokenDocument, options);
        }
export type GetTransactionsByTokenQueryHookResult = ReturnType<typeof useGetTransactionsByTokenQuery>;
export type GetTransactionsByTokenLazyQueryHookResult = ReturnType<typeof useGetTransactionsByTokenLazyQuery>;
export type GetTransactionsByTokenQueryResult = Apollo.QueryResult<GetTransactionsByTokenQuery, GetTransactionsByTokenQueryVariables>;
export const GetTokenPlotVolumeDocument = gql`
    query GetTokenPlotVolume($id: String!, $tokenId: String) {
  token(id: $id, tokenId: $tokenId) {
    id
    tokenId
    plotVolume {
      time
      value
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useGetTokenPlotVolumeQuery__
 *
 * To run a query within a React component, call `useGetTokenPlotVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenPlotVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenPlotVolumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetTokenPlotVolumeQuery(baseOptions: Apollo.QueryHookOptions<GetTokenPlotVolumeQuery, GetTokenPlotVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenPlotVolumeQuery, GetTokenPlotVolumeQueryVariables>(GetTokenPlotVolumeDocument, options);
      }
export function useGetTokenPlotVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenPlotVolumeQuery, GetTokenPlotVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenPlotVolumeQuery, GetTokenPlotVolumeQueryVariables>(GetTokenPlotVolumeDocument, options);
        }
export type GetTokenPlotVolumeQueryHookResult = ReturnType<typeof useGetTokenPlotVolumeQuery>;
export type GetTokenPlotVolumeLazyQueryHookResult = ReturnType<typeof useGetTokenPlotVolumeLazyQuery>;
export type GetTokenPlotVolumeQueryResult = Apollo.QueryResult<GetTokenPlotVolumeQuery, GetTokenPlotVolumeQueryVariables>;
export const GetTokenPlotLiquidityDocument = gql`
    query GetTokenPlotLiquidity($id: String!, $tokenId: String) {
  token(id: $id, tokenId: $tokenId) {
    id
    tokenId
    plotLiquidity {
      time
      value
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useGetTokenPlotLiquidityQuery__
 *
 * To run a query within a React component, call `useGetTokenPlotLiquidityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenPlotLiquidityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenPlotLiquidityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetTokenPlotLiquidityQuery(baseOptions: Apollo.QueryHookOptions<GetTokenPlotLiquidityQuery, GetTokenPlotLiquidityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenPlotLiquidityQuery, GetTokenPlotLiquidityQueryVariables>(GetTokenPlotLiquidityDocument, options);
      }
export function useGetTokenPlotLiquidityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenPlotLiquidityQuery, GetTokenPlotLiquidityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenPlotLiquidityQuery, GetTokenPlotLiquidityQueryVariables>(GetTokenPlotLiquidityDocument, options);
        }
export type GetTokenPlotLiquidityQueryHookResult = ReturnType<typeof useGetTokenPlotLiquidityQuery>;
export type GetTokenPlotLiquidityLazyQueryHookResult = ReturnType<typeof useGetTokenPlotLiquidityLazyQuery>;
export type GetTokenPlotLiquidityQueryResult = Apollo.QueryResult<GetTokenPlotLiquidityQuery, GetTokenPlotLiquidityQueryVariables>;
export const GetTokenPlotPriceDocument = gql`
    query GetTokenPlotPrice($id: String!, $tokenId: String) {
  token(id: $id, tokenId: $tokenId) {
    id
    tokenId
    plotPrice {
      time
      open
      close
      high
      low
      xtzUsdQuoteHistorical
    }
  }
}
    `;

/**
 * __useGetTokenPlotPriceQuery__
 *
 * To run a query within a React component, call `useGetTokenPlotPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTokenPlotPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTokenPlotPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetTokenPlotPriceQuery(baseOptions: Apollo.QueryHookOptions<GetTokenPlotPriceQuery, GetTokenPlotPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTokenPlotPriceQuery, GetTokenPlotPriceQueryVariables>(GetTokenPlotPriceDocument, options);
      }
export function useGetTokenPlotPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTokenPlotPriceQuery, GetTokenPlotPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTokenPlotPriceQuery, GetTokenPlotPriceQueryVariables>(GetTokenPlotPriceDocument, options);
        }
export type GetTokenPlotPriceQueryHookResult = ReturnType<typeof useGetTokenPlotPriceQuery>;
export type GetTokenPlotPriceLazyQueryHookResult = ReturnType<typeof useGetTokenPlotPriceLazyQuery>;
export type GetTokenPlotPriceQueryResult = Apollo.QueryResult<GetTokenPlotPriceQuery, GetTokenPlotPriceQueryVariables>;
export const GetAllTokensDocument = gql`
    query GetAllTokens($limit: Int, $offset: Int, $currency: CurrencyEnum) {
  tokens(limit: $limit, offset: $offset) {
    totalCount
    edges {
      node {
        id
        icon
        name
        standard
        volume24h
        price
        symbol
        tokenId
        priceChange(currency: $currency) {
          day
          week
          month
        }
        liquidity
      }
    }
  }
}
    `;

/**
 * __useGetAllTokensQuery__
 *
 * To run a query within a React component, call `useGetAllTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTokensQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetAllTokensQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTokensQuery, GetAllTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTokensQuery, GetAllTokensQueryVariables>(GetAllTokensDocument, options);
      }
export function useGetAllTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTokensQuery, GetAllTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTokensQuery, GetAllTokensQueryVariables>(GetAllTokensDocument, options);
        }
export type GetAllTokensQueryHookResult = ReturnType<typeof useGetAllTokensQuery>;
export type GetAllTokensLazyQueryHookResult = ReturnType<typeof useGetAllTokensLazyQuery>;
export type GetAllTokensQueryResult = Apollo.QueryResult<GetAllTokensQuery, GetAllTokensQueryVariables>;